module.exports = __webpack_public_path__ + "media/images/background_home_2480-1440w-d4186017.jpg";